import { Injectable } from '@angular/core';
import { SessionStorageService, StateService } from '../../../../../core';
import { Produtividade } from '../../kpis/adapters';
import { RepresentanteProdutividadeWidgetState, RepresentanteProdutividadeWidgetTabs } from './representante-produtividade-widget.state';

@Injectable()
/** Service para gerenciamento do state do widget de produtividade dos representantes */
export class RepresentanteProdutividadeWidgetStateService extends StateService<RepresentanteProdutividadeWidgetState> {
    constructor(sessionStorageService: SessionStorageService,) {
        super(
            sessionStorageService,
            {
                data: null,
                activeTab: RepresentanteProdutividadeWidgetTabs.GERAL
            }
        );
    }

    /** Seta os dados */
    setData(data: Produtividade): void {
        this.state.data = data;
        this.propagateState();
    }

    /** Seta a tab ativa */
    setActiveTab(tab: RepresentanteProdutividadeWidgetTabs) {
        this.state.activeTab = tab;
        this.propagateState();
    }
}
